import {
    Handler,
    HasOnError,
    HasOnSuccess,
    replaceInChain,
    addToEndOfChain
} from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter, RequestDataFromApi } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import {
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import {pushDataToDataLayer} from "@NA/Overrides/Common/Utilities/CustomTracking";

type Parameter = (GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter) &
    HasOnSuccess<ProductModel[]> &
    HasOnError<string>;
type Props = {
    apiParameter: GetProductCollectionApiV2Parameter | GetRelatedProductCollectionApiV2Parameter;
    apiResult: ProductCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterCustom: HandlerType = props => {
    const { onSuccess, onError, ...parameter } = props.parameter;
    props.apiParameter = { ...parameter, expand: [...(parameter.expand || []), "properties"] };
};



replaceInChain(chain, PopulateApiParameter, PopulateApiParameterCustom);
